/* eslint-disable object-curly-newline */
import React, { useState, useEffect, useRef, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import getUnregisteredPayments from '../../../api/graphql/queries/getUnregisteredPayments';
import getCollatedPayments from '../../../api/graphql/queries/getCollatedPayments';
import getProducts from '../../../api/graphql/queries/getProducts';

import Filter from '../../Tabs/Filter';
import SubscriptionsTable from './SubscriptionsTable';
import UnregisteredPaymentsToolbar from './UnregisteredPaymentsToolbar';
// import SubscriptionsForm from './SubscriptionsForm';
import UnregisteredPaymentsAssignPayment from './UnregisteredPaymentsAssignPayment';
import Modal from '../../Modal/Modal';
import LoadIcon from '../../LoadIcon';

const UnregisteredPaymentsContainer = () => {
  const [productList, setProductList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isCreateModalOn, setIsCreateModalOn] = useState(false);
  const [isDisplayModalOn, setIsDisplayModalOn] = useState(false);
  const [isModifyModalOn, setIsModifyModalOn] = useState(false);
  const [isDeleteModalOn, setIsDeleteModalOn] = useState(false);
  const [formOutput, setFormOutput] = useState({});
  const [currItemData, setCurrItemData] = useState([]);
  const [toggleDeleteInfoScreen, setToggleDeleteInfoScreen] = useState([]);
  const [total, setTotal] = useState(0);
  const [query, setQuery] = useState('');
  const [fetchCollatedPaymentsInProgress, setFetchCollatedPaymentsInProgress] = useState(false);
  const [lastFetchCollatedPayments, setLastFetchCollatedPayments] = useState(null);
  const [downloadingAllInProgress, setDownloadingAllInProgress] = useState(false);
  const [downloadingInProgress, setDownloadingInProgress] = useState(false);

  // Filtering items:
  const [email, setEmail] = useState(null);
  const [fullName, setFullName] = useState(null);
  const [country, setCountry] = useState(null);
  const [purchaseId, setPurchaseId] = useState(null);
  const [provider, setProvider] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [finishDate, setFinishDate] = useState(null);

  // Sorting items:
  const [sorting, setSorting] = useState(['datePayment', -1]);

  // Pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [previousPage, setPreviousPage] = useState(0);
  const [avoidEffect, setAvoidEffect] = useState(false);

  const isMounted = useRef(true);

  const toggleCreateModal = () => {
    setIsCreateModalOn(!isCreateModalOn);
  };

  const toggleDisplayModal = (row) => {
    setIsDisplayModalOn(!isDisplayModalOn);
    setCurrItemData(row);
  };

  const toggleModifyModal = (row) => {
    setIsModifyModalOn(!isModifyModalOn);
    setCurrItemData(row);
  };

  const toggleDeleteModal = (row) => {
    setIsDeleteModalOn(!isDeleteModalOn);
    setCurrItemData(row);
  };

  const formOutputHandler = (value) => {
    setFormOutput(value);
    // we would send this to the DB to create an entry
  };

  const handleClick = (action, row) => {
    switch (action) {
      case 'create':
        toggleCreateModal();
        break;
      case 'display':
        toggleDisplayModal(row);
        break;
      case 'modify':
        toggleModifyModal(row);
        break;
      case 'delete':
        toggleDeleteModal(row);
        break;
      case 'closeDeleteItem':
        setToggleDeleteInfoScreen(!toggleDeleteInfoScreen);
        break;
      default:
        console.log('wrong action!');
        break;
    }
  };


  const columns = [
    { field: null,
      headerName: null,
      type: 'button',
      label: 'Edit',
      sortable: true,
      align: 'center',
      clickFunc: (row) => {
        console.log('clickFunc');
        return (
          handleClick('display', row)
        );
      },
    },
    { field: '_id', type: 'string', hide: true, isId: true, align: 'left' },
    { field: 'datePayment', headerName: 'Date payment', type: 'date', sortable: true, align: 'left' },
    { field: 'providerEmail', headerName: 'Email', type: 'string', sortable: true, align: 'left' },
    { field: 'fullName', headerName: 'Name', type: 'string', sortable: true, align: 'left' },
    { field: 'purchaseId', headerName: 'PurchaseId', type: 'string', sortable: true, align: 'left' },
    { field: 'paypalAccountId', headerName: 'AccountId', type: 'string', sortable: true, align: 'left' },
    { field: 'transactionId', headerName: 'TransactionId', type: 'string', sortable: true, align: 'left' },
    { field: 'currency', headerName: 'currency', type: 'string', sortable: true, align: 'left' },
    { field: 'amount', headerName: 'amount', type: 'string', sortable: true, align: 'left' },
    // { field: 'transactionStatus', headerName: 'transactionStatus', type: 'string', sortable: true, align: 'left' },
    { field: 'transactionSubject', headerName: 'transactionSubject', type: 'string', sortable: true, align: 'left' },
    { field: 'country', headerName: 'country', type: 'string', sortable: true, align: 'left' },
    { field: 'provider', headerName: 'Provider', type: 'string', sortable: true, align: 'left' },
  ];

  const formatValue = ({ column, row, value, csv = false }) => {
    switch (column.type) {
      case 'date':
        return value ? new Date(value).toLocaleString().replace(',', '') : '';
      case 'boolean':
        return value ? 'X' : '';
      case 'array':
        if (!value) return '';
        return csv ? `"${value.join()}"` : value.join();
      case 'button':
        return (
          <div className="px-3 md:mb-0">
            <div className="mb-2">
              &nbsp;
            </div>
            <button className="font-americaMonoBold text-xs px-3 py-1 rounded-full uppercase bg-greyFilter" type="button" id="download" onClick={e => column.clickFunc(row)}>
              {column.label}
            </button>
          </div>
        );
      case 'string':
      default:
        return value || '';
    }
  };

  useEffect(() => () => {
    isMounted.current = false;
  }, []);

  useEffect(() => {
    if (avoidEffect) {
      console.log('Avoiding effect');
      return;
    }
    let from = page * rowsPerPage;
    let to = (page + 1) * rowsPerPage;
    if (previousPage === page) {
      setAvoidEffect(true);
      setPage(0);
      from = 0;
      to = rowsPerPage;
    } else {
      from = page * rowsPerPage;
      to = (page + 1) * rowsPerPage;
      setPreviousPage(page);
    }
    console.log('Calling getUnregisteredPayments()');
    getUnregisteredPayments({
      email,
      fullName,
      country,
      purchaseId,
      provider,
      startDate,
      finishDate,
      from,
      to,
      sortingField: sorting[0],
      sortingType: sorting[1],
    }).then((paymentsDataObject) => {
      if (!isMounted.current) return;

      if (paymentsDataObject) {
        if (paymentsDataObject.isAuth) {
          setTotal(paymentsDataObject.total);
          setQuery(paymentsDataObject.query);
          setFilteredData(paymentsDataObject.payments);
          setIsLoading(false);
        } else {
          console.log('getUnregisteredPayments failed!');
        }
      } else {
        console.log('paymentsData = null');
      }
      setAvoidEffect(false);
    });
  }, [
    email,
    fullName,
    country,
    purchaseId,
    provider,
    startDate,
    finishDate,
    page,
    rowsPerPage,
    sorting,
    lastFetchCollatedPayments,
  ]);

  useEffect(() => {
    getProducts(null, 'rdl-subscription').then((productListReceived) => {
      if (isMounted.current) setProductList(productListReceived);
    });
  }, []);

  // const updateSearch = (val) => {
  //   setFilterText(val);
  //   setFilteredData(initialItems.filter(item => item.email.toLowerCase().includes(val.toLowerCase())));
  // };

  const handleFetchCollatedPayments = async () => {
    setFetchCollatedPaymentsInProgress(true);
    const response = await getCollatedPayments();
    setFetchCollatedPaymentsInProgress(false);
    setLastFetchCollatedPayments(new Date());
  };

  // Fastest algorythm to create CSV
  // Warning: if the data has commas or newlines this will not be a valid CSV
  const makeCsv = (rawData) => {
    const csvArr = new Array(rawData.length + 1);
    const visibleColumns = columns.filter(column => !column.hide);
    const numColumns = visibleColumns.length;
    const row = new Array(numColumns);

    // Set csv column titles
    csvArr[0] = visibleColumns.map(column => column.headerName).join(',');

    // Set data
    for (let rowNum = 0; rowNum < rawData.length; rowNum++) {
      for (let colNum = 0; colNum < numColumns; colNum++) {
        row[colNum] = formatValue({ column: visibleColumns[colNum], value: rawData[rowNum][visibleColumns[colNum].field], csv: true });
      }
      csvArr[rowNum + 1] = row.join(',');
    }
    return csvArr.join('\n');
  };

  const handleDownload = async () => {
    const chunkSize = 5000;

    setDownloadingInProgress(true);

    // Get total payments count:
    const { total: totalPayments } = await getUnregisteredPayments({
      email,
      fullName,
      purchaseId,
      provider,
      startDate,
      finishDate,
      from: 0,
      to: 0,
    });

    const promises = [];

    // Get payments by chunks
    for (let chunk = 0; chunk < Math.ceil(totalPayments / chunkSize); chunk++) {
      promises.push(getUnregisteredPayments({
        email,
        fullName,
        country,
        purchaseId,
        provider,
        startDate,
        finishDate,
        from: chunk * chunkSize,
        to: chunkSize,
      }));
    }

    // Get responses
    Promise.all(promises).then((rawDataChunks) => {
      const rawData = [];
      rawDataChunks.forEach(chunk => rawData.push(...chunk.payments));

      const data = makeCsv(rawData || []);
      const element = document.createElement('a');
      const file = new Blob([data], { type: 'text/csv;charset=utf-8;' });
      element.href = URL.createObjectURL(file);
      element.download = 'unregisteredPayments.csv';
      document.body.appendChild(element); // Required for this to work in FireFox
      element.click();
      setDownloadingInProgress(false);
    });
  };

  const handleDownloadAll = async () => {
    const chunkSize = 5000;

    setDownloadingAllInProgress(true);

    // Get total payments count:
    const { total: totalPayments } = await getUnregisteredPayments({
      from: 0,
      to: 0,
    });

    const promises = [];

    // Get payments by chunks
    for (let chunk = 0; chunk < Math.ceil(totalPayments / chunkSize); chunk++) {
      promises.push(getUnregisteredPayments({
        from: chunk * chunkSize,
        to: chunkSize,
      }));
    }

    // Get responses
    Promise.all(promises).then((rawDataChunks) => {
      const rawData = [];
      rawDataChunks.forEach(chunk => rawData.push(...chunk.payments));

      const data = makeCsv(rawData || []);
      const element = document.createElement('a');
      const file = new Blob([data], { type: 'text/csv;charset=utf-8;' });
      element.href = URL.createObjectURL(file);
      element.download = 'unregisteredPayments.csv';
      document.body.appendChild(element); // Required for this to work in FireFox
      element.click();
      setDownloadingAllInProgress(false);
    });
  };

  return (
    <Fragment>
      <div className="w-full bg-white">
        <div className="flex justify-between mb-4">
          <span className="font-americaMonoBold text-14 uppercase">
            Total:
            {total}
          </span>
        </div>

        {isDisplayModalOn && (
          <Modal title="Assign unregistered payment" handleClick={handleClick} type="display">
            <UnregisteredPaymentsAssignPayment
              handleClick={handleClick}
              productList={productList}
              formInput={currItemData}
              action="display"
            />
          </Modal>
        )}

        <div className="mt-4">
          {!isLoading ? (
            <>
              <UnregisteredPaymentsToolbar
                email={email}
                setEmail={setEmail}
                name={fullName}
                setName={setFullName}
                purchaseId={purchaseId}
                setPurchaseId={setPurchaseId}
                provider={provider}
                setProvider={setProvider}
                startDate={startDate}
                setStartDate={setStartDate}
                finishDate={finishDate}
                setFinishDate={setFinishDate}
                country={country}
                setCountry={setCountry}
                handleFetchCollatedPayments={handleFetchCollatedPayments}
                fetchCollatedPaymentsInProgress={fetchCollatedPaymentsInProgress}
                handleDownload={handleDownload}
                handleDownloadAll={handleDownloadAll}
                downloadingInProgress={downloadingInProgress}
                downloadingAllInProgress={downloadingAllInProgress}
              />

              <SubscriptionsTable
                tableData={filteredData}
                columns={columns}
                stickyHeader
                total={total}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                sorting={sorting}
                setSorting={setSorting}
                formatValue={formatValue}
              />

              <div style={{ color: '#fff' }}>
                {query}
              </div>
            </>
          ) : <LoadIcon />}
        </div>
      </div>
    </Fragment>
  );
};

UnregisteredPaymentsContainer.propTypes = {
};

export default withRouter(UnregisteredPaymentsContainer);
